import React from 'react';
import { Container } from './styles';

const TextArea = ({
  onChange,
  value,
  title,
  placeholder,
  rows,
  additionalstyle,
  required,
  name,
  mainPage,
  resize,
  error,
  errorMessage,
  description 
}) => {
  return (
    <Container
      additionalstyle={additionalstyle}
      mainPage={mainPage}
      resize={resize}
    >
      {title && <div className="label">
        {title}
        {required? <span className='warning'> *</span>: null}
      </div>}
      <textarea
        name={name}
        value={value}
        rows={rows}
        placeholder={placeholder}
        onChange={onChange}
        required={required}
      />
      {error? <div className="warning">{errorMessage?.length? errorMessage: 'This is a required field.'}</div>: null}
      {description? <div className="description">{description}</div>: null}
    </Container>
  );
}

export default TextArea;

